import React from 'react';

/**
 * A table header cell (<th>) with a draggable resize handle on the right edge.
 *
 * Props:
 * - colKey: string key for this column
 * - width: current width in px
 * - onResizeStart: (event, colKey) => void
 * - children: header content
 * - className: additional classes for the th
 * - style: additional inline styles
 * - All other props passed to <th>
 */
export default function ResizableHeader({ colKey, width, onResizeStart, children, className = '', style = {}, ...rest }) {
  return (
    <th
      className={`relative group ${className}`}
      style={{ width, minWidth: 40, ...style }}
      {...rest}
    >
      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {children}
      </div>
      <div
        className="absolute right-0 top-0 bottom-0 cursor-col-resize z-20"
        style={{ width: '8px', marginRight: '-4px' }}
        onMouseDown={(e) => onResizeStart(e, colKey)}
        onTouchStart={(e) => onResizeStart(e, colKey)}
        title="Drag to resize column"
        data-testid={`resize-handle-${colKey}`}
      >
        <div className="w-full h-full opacity-0 group-hover:opacity-100 hover:opacity-100 transition-opacity bg-blue-400" style={{ width: '3px', margin: '0 auto' }} />
      </div>
    </th>
  );
}
